import { render, staticRenderFns } from "./LiveSetting.vue?vue&type=template&id=3d5602dc&"
import script from "./LiveSetting.vue?vue&type=script&lang=js&"
export * from "./LiveSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports